import { render, staticRenderFns } from "./searchTextComponent.vue?vue&type=template&id=28d3de3c"
import script from "./searchTextComponent.vue?vue&type=script&lang=js"
export * from "./searchTextComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports